import React, { useState, useRef, useEffect } from 'react';
import SlidePanel from '../shared/SlidePanel';
import '../shared/ui.css';
import './ServiceDetailPanel.css';

/**
 * CategoryDetailPanel — editable category summary in a SlidePanel.
 * Replaces the old MobileDotPopup + MessagePopupBody + Dropdown trio
 * for category management. Works on both mobile and desktop.
 */
const CategoryDetailPanel = ({ category, onClose, onSave, onDelete, itemCount = 0, itemLabel = 'services' }) => {
    const slidePanelRef = useRef(null);
    const inputRef = useRef(null);
    const [name, setName] = useState(category?.name || '');
    const [error, setError] = useState('');

    useEffect(() => {
        setName(category?.name || '');
        setError('');
    }, [category]);

    const handleSave = () => {
        const trimmed = name.trim();
        if (!trimmed) {
            setError('Category name is required');
            return;
        }
        if (trimmed === category?.name) {
            onClose();
            return;
        }
        onSave(category?.id, trimmed);
    };

    const handleDelete = () => {
        if (onDelete) onDelete(category?.id, category?.name);
    };

    return (
        <SlidePanel
            ref={slidePanelRef}
            onClose={onClose}
            className="sdp-panel"
            width={380}
            compact
        >
            {/* Header */}
            <div className="sdp-header">
                <div className="sdp-header-info">
                    <h2 className="sdp-header-name">{category?.name || 'Category'}</h2>
                    {itemCount > 0 && (
                        <span className="sdp-header-category">
                            {itemCount} {itemCount === 1 ? itemLabel.replace(/s$/, '') : itemLabel}
                        </span>
                    )}
                </div>
                <button className="beu-icon-btn" onClick={onClose}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                </button>
            </div>

            {/* Body */}
            <div className="sdp-body">
                <div className="sdp-section">
                    <p className="beu-section-label">Category Name</p>
                    <input
                        ref={inputRef}
                        type="text"
                        className="cdp-name-input"
                        value={name}
                        onChange={(e) => { setName(e.target.value); setError(''); }}
                        placeholder="Enter category name"
                    />
                    {error && <span className="cdp-error">{error}</span>}
                </div>
            </div>

            {/* Footer */}
            <div className="sdp-footer">
                <button type="button" className="sdp-btn sdp-btn--secondary" onClick={handleDelete}>
                    Delete
                </button>
                <button type="button" className="sdp-btn sdp-btn--primary" onClick={handleSave}>
                    Save
                </button>
            </div>
        </SlidePanel>
    );
};

export default CategoryDetailPanel;
